export default __webpack_public_path__ + "static/media/Viterbi.6909e86c.png";